module.exports = __WEBPACK_EXTERNAL_MODULE__5329__;